/**
 * Shared Ask AI context.
 *
 * The Ask AI drawer is mounted globally in App.js, outside the router, so it
 * cannot read a page's local filter state through props or context. Pages that
 * own filters publish them here; the drawer reads them when a question is sent.
 *
 * Without this, Ask AI silently answered for a different period than the one
 * the CEO had selected on screen.
 */
let activeContext = null;

/** Publish the current page's analytics scope. Pass null to clear. */
export function setAskAiContext(ctx) {
  activeContext = ctx && Object.keys(ctx).length ? { ...ctx } : null;
}

export function getAskAiContext() {
  return activeContext ? { ...activeContext } : null;
}

export function clearAskAiContext() {
  activeContext = null;
}

/**
 * Convert the CEO filter bar's state into the wire format the backend applies.
 * Only non-empty values are sent; a field the backend cannot map is ignored
 * there rather than guessed at.
 */
export function ceoFiltersToAskAiContext(filters) {
  if (!filters) return null;
  const ctx = {};
  if (filters.dateFrom) ctx.date_from = filters.dateFrom;
  if (filters.dateTo) ctx.date_to = filters.dateTo;
  if (filters.periodMode) ctx.period_label = filters.periodMode;
  ["buyer", "consignee", "country", "grade", "variety", "brand", "coldStore", "plant"].forEach((k) => {
    if (filters[k]) ctx[k] = filters[k];
  });
  return Object.keys(ctx).length ? ctx : null;
}

/** Open the drawer, optionally publishing the caller's scope first. */
export function openAskAi(ctx) {
  if (ctx !== undefined) setAskAiContext(ctx);
  window.dispatchEvent(new CustomEvent("quantira:open-ask-ai"));
}
